{
	"title": "Weightlifting results",
	"help": "Type the weight, then o for a good lift or x for a no lift: 125 o. After a good lift, add the record it set: 125 o WR. Three no lifts in the Snatch or in the Clean & Jerk sets the status to DNF.",
	"grid": {
		"label": "Results: {{meet}}",
		"caption": "Snatch and Clean & Jerk attempts, best lifts, total, rank and save state for each lifter",
		"seq": "Seq",
		"lot": "Lot",
		"competitor": "Athlete",
		"bodyweight": "BW (kg)",
		"entry": "Entry",
		"section": {
			"SNATCH": "Snatch",
			"CLEAN_JERK": "Clean & Jerk"
		},
		"attemptHead": "{{n}}",
		"attemptLong": "{{section}}, attempt {{n}}",
		"best": "Best",
		"bestLong": "Best {{section}}",
		"total": "Total (kg)",
		"rank": "Rank",
		"state": "Save state",
		"irm": "Status",
		"irmAria": "{{name}}, status",
		"irmHint": "OK, or DNS (did not start), DNF (did not finish: three no lifts in a section) or DSQ (disqualified)",
		"statusOk": "OK",
		"records": "Records",
		"recordsHint": "Records set by the total: WR, AR, GR",
		"recordsAria": "{{name}}, records set by the total",
		"liftAria": "{{name}}, {{section}} attempt {{n}}",
		"waiting": "Waiting for the lifter",
		"dnfHint": "Three no lifts in a section: no total (DNF)."
	},
	"lift": {
		"good": "Good lift",
		"noLift": "No lift",
		"declared": "Declared, not lifted yet"
	},
	"view": {
		"label": "Show",
		"start": "Start order",
		"result": "Result order",
		"resultHint": "Ranked by what is saved: rows move after a save."
	},
	"entry": {
		"weight": "Type the weight in kilograms, for example 120.",
		"range": "Whole kilograms, from 1 to {{max}}.",
		"mark": "After the weight, type o (good lift) or x (no lift), for example 120 o.",
		"recordNotGood": "Only a good lift sets a record: 125 o WR.",
		"records": "Records are codes such as WR, AR or GR, at most {{max}}."
	},
	"empty": {
		"title": "No lifters on the start list yet",
		"body": "Set the Meet status to Start list to add them."
	},
	"tsrLive": {
		"label": "Live from TSR",
		"badge": "Live from TSR",
		"status": {
			"waiting": "Waiting",
			"live": "Live",
			"paused": "Paused",
			"completed": "Completed"
		},
		"attempt": "Attempt {{n}}",
		"kg": "{{weight}} kg",
		"noLifter": "No lifter on the platform",
		"clock": "Attempt clock",
		"referees": "Referee lights",
		"decision": {
			"good": "Good lift",
			"no-lift": "No lift",
			"none": "Not decided yet"
		},
		"readOnly": "Shown live from the TSR platform. Results come into this grid when TSR presses Save Meet."
	}
}
